module.exports = __webpack_public_path__ + "91404f4e5cb3be399b8c1ea9380878ad.svg";